import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ToasterService } from 'angular2-toaster';
import { DataService } from '../../services/data-sharing/data.service';
import { EesDesService } from '../../services/ees-des.service';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { WebServiceService } from '../../services/web-service.service';

@Component({
  selector: 'app-support-popup',
  templateUrl: './support-popup.component.html',
  styleUrls: ['./support-popup.component.scss']
})
export class SupportPopupComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  defaultSupportPopupMessage: string = 'Important Support Update\n\nDear User,\n\nTo provide you with better and faster support, all service requests, issue reports, and queries will now be handled exclusively through our official support email.\n\n📧 Support Email: care@tyasuite.com\n\nKindly use this email for all future communications. This will help us track your requests efficiently and ensure timely resolution.\n\nThank you for choosing TYASuite!';
  showSupportPopup: boolean = false;
  supportPopupMessage: string = '';
  supportPopupAcknowledging: boolean = false;

  constructor(
    private popupService: DataService,
    private webService: WebServiceService,
    private toasterService: ToasterService,
    private localStorageService: LocalStorageService,
    private eesdesService: EesDesService,
    private router: Router
  ) {}

  ngOnInit() {
    this.popupService.popupState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(show => {
        this.showSupportPopup = show;
        if (show) {
          this.supportPopupAcknowledging = false;
          this.supportPopupMessage = this.popupService.getSupportPopupMessage() || this.defaultSupportPopupMessage;
          // Never keep popup open off Dashboard (e.g. delayed open after leave).
          if (!this.isDashboardRoute()) {
            this.popupService.open(false);
          }
        } else {
          this.supportPopupAcknowledging = false;
        }
      });

    this.popupService.supportPopupMessage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(message => {
        if (message) {
          this.supportPopupMessage = message;
        }
      });

    // Leave Dashboard (Back / menu nav) → hide popup only. Do NOT save pop_show_date.
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        if (!this.isDashboardRoute() && this.showSupportPopup) {
          this.popupService.open(false);
        }
      });
  }

  private isDashboardRoute(): boolean {
    const hash = (window.location.hash || '').replace(/^#/, '').split('?')[0];
    const path = hash || (this.router.url || '').split('?')[0];
    const normalized = path && path.charAt(0) === '/' ? path : '/' + (path || '');
    return normalized === '/dashboard' || normalized.endsWith('/dashboard');
  }

  acknowledgeSupportPopup() {
    if (this.supportPopupAcknowledging) {
      return;
    }

    const today = new Date();
    const popShowDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    const payload = {
      "project": 'operation',
      "activity_type": 'login',
      "company_id": this.localStorageService.getEmpCompanyId() ? this.localStorageService.getEmpCompanyId() : 0,
      "user_id": this.localStorageService.getUserId(),
      "user_role_id": this.eesdesService.get('emp_role', localStorage.getItem('emp_role')) ? this.eesdesService.get('emp_role', localStorage.getItem('emp_role')) : '0',
      "pop_show_date": popShowDate
    };

    this.supportPopupAcknowledging = true;
    this.webService.commonPostMethod("User_activity/save_user_activity", payload)
      .subscribe(
        data => {
          if (data.status) {
            localStorage.setItem('pop_show_date', popShowDate);
            this.popupService.open(false);
            // Keep spinner until overlay unmounts — avoids OK text flash on close.
            return;
          }
          this.supportPopupAcknowledging = false;
          this.toasterService.pop("error", "Error", data.message ? data.message : "Unable to acknowledge the support update");
        },
        error => {
          this.supportPopupAcknowledging = false;
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1294910137/src/src/app/shared/components/support-popup/support-popup.component.ts